module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/_cache/contact-5.vue");


//////////////////
// WEBPACK FOOTER
// ./src/assets/md/contact.md
// module id = 214
// module chunks = 0